import React from 'react';
import { Link } from 'react-router-dom';
import xIcon from '../../assets/x-icon.png';

function Footer() {
  return (
    <div className="footer-wrapper">
    <footer className="footer">
    <div className="footer-content">
    <p>&copy; 2026 PinkCatAI. <Link to="/legal">Terms of Service and Privacy Policy</Link>.</p>
    <div>
        Write a message ✉️ <a href="mailto:supportpinkcatai@gmail.com">supportpinkcatai@gmail.com</a>
        <a href="https://x.com/janagoespro" target="_blank" rel="noopener noreferrer" className="twitter-link" style={{ marginLeft: '10px' }}>
            <img src={xIcon} alt="X Icon" className="twitter-icon" />
        </a>
    </div>
    </div>
    </footer>
    </div>
  );
}

export default Footer;